module.exports = __webpack_public_path__ + "static/assets/7555bb7bc56a666800c3973f9aa37706.png";